import {
    CATALOG_CLOSE,
    CATALOG_RECORD_LIST_LOADED,
    CATALOG_RECORD_LIST_LOAD_ERROR,
    CATALOG_CHANGE_SELECTED_SERVICE,
    CATALOG_CHANGE_CATALOG_MODE,
    CATALOG_ADD_CATALOG_SERVICE,
    CATALOG_DELETE_CATALOG_SERVICE,
    CATALOG_ADD_SERVICE,
    CATALOG_DELETE_SERVICE,
    CATALOG_INITED,
    CATALOG_SET_LOADING,
    CATALOG_SAVING_SERVICE,
    CATALOG_CHANGE_TEXT,
    CATALOG_TEXT_SEARCH,
    CATALOG_ADD_LAYER_FROM_CATALOGS
} from './CatalogActions';
import {getLayerId} from '@config/utils'

import csw from './api/CSW';
import wms from './api/WMS';
import wmts from './api/WMTS';
let API = {
    csw,
    wms,
    wmts,
};

export default {
    data() {
        return {

        }
    },
    computed: {

    },
    methods: {
        dispatchCatalogAction(params){
            this.$store.dispatch('catalogAction', params);
        },
        setLoading(loading = false) {
            this.dispatchCatalogAction({
                type: CATALOG_SET_LOADING,
                loading
            });
        },
        savingService(status) {
            this.dispatchCatalogAction({
                type: CATALOG_SAVING_SERVICE,
                status
            });
        },
        changeSelectedService(service) {
            this.dispatchCatalogAction({
                type: CATALOG_CHANGE_SELECTED_SERVICE,
                selectedService: service,
                result: null,
                loadingError: null,
                layerError: null
            });
        },
        changeCatalogMode(mode, isNew, params={}) {
            this.dispatchCatalogAction({...{
                type: CATALOG_CHANGE_CATALOG_MODE,
                mode,
                isNew
            }, ...params});
        },
        addCatalogService(service) {
            this.dispatchCatalogAction({
                type: CATALOG_ADD_CATALOG_SERVICE,
                service
            });
        },
        addService(service) {
            this.addCatalogService(service);
        },
        deleteCatalogService(service) {
            this.dispatchCatalogAction({
                type: CATALOG_DELETE_CATALOG_SERVICE,
                service
            });
        },
        deleteService(service) {
            this.deleteCatalogService(service);
        },
        addLayerFromCatalogs(layer, options){
            const newLayer = (layer.id) ? layer : Object.assign({}, layer, {id: getLayerId(layer)});
            this.dispatchCatalogAction({
                type: CATALOG_ADD_LAYER_FROM_CATALOGS,
                layer: newLayer,
                options
            });
            // TODO: Passar a TOC para a vuex
            this.$eventBus.publish(this.moduleCode, 'toc.add-layer-from-catalogs', {layer: newLayer, options});
        },
        changeText(text) {
            this.dispatchCatalogAction({
                type: CATALOG_CHANGE_TEXT,
                text
            });
        },
        catalogInited() {
            this.dispatchCatalogAction({
                type: CATALOG_INITED
            });
        },
        initCatalog(apis = API) {
            Object.keys(apis).forEach((name) => {
                apis[name].reset();
            });
            this.catalogInited();
        },
        catalogClose() {
            this.dispatchCatalogAction({
                type: CATALOG_CLOSE
            });
        },
        recordSearch({ format, url, startPosition, maxRecords, text, options }) {
            return new Promise((resolve, reject) => {
                this.setLoading(true);
                resolve(API[format].textSearch(
                    url,
                    startPosition,
                    maxRecords,
                    text,
                    { options }
                    // { options, ...catalogSearchInfoSelector(store.getState()) }
                ));
            })
            .then((result) => {
                if (result.error) {
                    this.recordsLoadError(result);
                }else{
                    return this.recordsLoaded({
                        url,
                        startPosition,
                        maxRecords,
                        text
                    }, result);
                }
            })
            .catch((e) => {
                this.recordsLoadError(e);
            });
        },
        // textSearch({format, url, startPosition, maxRecords, text, options = {}} = {}) {
        //     this.dispatchCatalogAction({
        //         type: CATALOG_TEXT_SEARCH,
        //         format,
        //         url,
        //         startPosition,
        //         maxRecords,
        //         text,
        //         options
        //     });
        // },
        getRecords(format, url, startPosition = 1, maxRecords, filter, options) {
            this.setLoading(true);
            API[format].getRecords(url, startPosition, maxRecords, filter, options)
            .then((result) => {
                if (result.error) {
                    this.recordsLoadError(result);
                } else {
                    this.recordsLoaded({
                        url,
                        startPosition,
                        maxRecords,
                        filter
                    }, result);
                }
            }).catch((e) => {
                this.recordsLoadError(e);
            });
        },
        recordsLoaded(options, result) {
            this.dispatchCatalogAction({
                type: CATALOG_RECORD_LIST_LOADED,
                searchOptions: options,
                result: result
            });
        },
        recordsLoadError(e) {
            this.dispatchCatalogAction({
                type: CATALOG_RECORD_LIST_LOAD_ERROR,
                error: e
            });
        },
        recordsNotFound(records = "") {
            return {
                title: "Error",
                message: "Some records have not been found: {records} Please check the query param url",
                values: {records}
            };
        }
    },
};